import {FC, useState, createContext, useContext, useMemo} from 'react'
import {
  ID,
  ListViewContextProps,
  WithChildren,
  calculateIsAllDataSelected,
  calculatedGroupingIsDisabled,
  groupingOnSelect,
  groupingOnSelectAll,
  initialListView,
} from '../../../_metronic/helpers'
import {useUserListProvider} from './UserListProvider'

export const UserListSelectContext = createContext<ListViewContextProps>(initialListView)

const UserListSelectProvider: FC<WithChildren> = ({children}) => {
  const [selected, setSelected] = useState<Array<ID>>(initialListView.selected)
  const [itemIdForUpdate, setItemIdForUpdate] = useState<ID | undefined>(
    initialListView.itemIdForUpdate
  )
  const {isLoading, filteredUser: data} = useUserListProvider()
  const disabled = useMemo(() => calculatedGroupingIsDisabled(isLoading, data), [isLoading, data])
  const isAllSelected = useMemo(() => calculateIsAllDataSelected(data, selected), [data, selected])

  return (
    <UserListSelectContext.Provider
      value={{
        selected,
        itemIdForUpdate,
        setItemIdForUpdate,
        disabled,
        isAllSelected,
        onSelect: (id: ID) => {
          groupingOnSelect(id, selected, setSelected)
        },
        onSelectAll: () => {
          groupingOnSelectAll(isAllSelected, setSelected, data)
        },
        clearSelected: () => {
          setSelected([])
        },
      }}
    >
      {children}
    </UserListSelectContext.Provider>
  )
}

const useUserListSelectProvider = () => useContext(UserListSelectContext)

export {UserListSelectProvider, useUserListSelectProvider}
